import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { API } from "@/lib/api";

export default function SpecialsSection() {
  const [specials, setSpecials] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/specials`)
      .then((res) => setSpecials(res.data))
      .catch(() => setSpecials([]));
  }, []);

  if (!specials || specials.length === 0) return null;

  return (
    <section
      id="specials"
      data-testid="specials-section"
      className="relative py-20 sm:py-28 border-t border-disco-lavender/20 bg-disco-lavender/[0.04]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-12"
        >
          <p className="text-disco-lavender text-xs font-semibold tracking-[0.35em] uppercase mb-4 flex items-center gap-2">
            <Sparkles size={14} />
            This Week Only
          </p>
          <h2 className="font-display uppercase leading-[0.9] tracking-tight text-5xl sm:text-7xl text-[#F8F8F8]">
            Specials <span className="neon-yellow">on deck</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {specials.map((special, i) => (
            <motion.div
              key={special.id}
              data-testid={`special-card-${special.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="relative border border-disco-lavender/30 bg-black/40 backdrop-blur-xl p-7 transition-colors duration-300 hover:border-disco-lavender/60"
            >
              {special.price && (
                <span
                  data-testid={`special-price-${special.id}`}
                  className="absolute top-5 right-5 rounded-full bg-disco-lavender text-disco-void text-sm font-bold px-3.5 py-1"
                >
                  {special.price}
                </span>
              )}
              <h3 className="font-display uppercase tracking-wide text-2xl sm:text-3xl text-[#F8F8F8] leading-none pr-16">
                {special.title}
              </h3>
              {special.description && (
                <p className="mt-3 text-sm text-zinc-300/90 font-light">{special.description}</p>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
